export default __webpack_public_path__ + "static/media/cross-black.5228679d.svg";